export const PopupHintInfoIconCssClasses = "icon icon-icon-info";
export const amountIconClasses = "icon icon__currency";
